import costAllocator from "../../../utils/services/project/accounting/costAllocatorService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(costAllocator);
let roles = rolesTemplate(costAllocator);

/**
 * @return {string}
 */
function FactorParser(factors = {}) {
  //check case 1:0.2;2:0,3
  let keys = Object.keys(factors).sort();
  let stringForCheck = Array.from(Array(keys.length + 1).keys()).join(",");
  if ("0," + keys.join(",") === stringForCheck) {
    return keys.map(i => factors[i]).join("; ");
  }
  //check case factor:0.2;factor1:0,3
  return Object.entries(factors)
    .map(i => `${i[0]}: ${i[1]}`)
    .join("; ");
}
function FactorDecoder(factors = "") {
  let factorsArray = factors.split(/ *; */);
  let index = 1;

  return Object.fromEntries(
    factorsArray
      .map(val => val.split(/ *: */))
      .map((val, i, arr) => {
        if (!val[1]) {
          let arrClone = [...arr];
          while (
            arrClone.find(i => i.length === 2 && `${i[0]}` === `${index}`)
          ) {
            index++;
          }
          val.unshift(index);
        }
        return val;
      })
  );
}
function prepareItem(i, types) {
  i._provider = i._provider || { id: null };
  i._consumer = i._consumer || { id: null };

  if (i._provider) {
    i.provider_name = i._provider.name;
    i.provider_id = i._provider.id;
  }
  if (i._consumer) {
    i.consumer_name = i._consumer.name;
    i.consumer_id = i._consumer.id;
  }

  i.type += "";
  i.type_name = (types.find(item => item.value === i.type) || {}).text || "";
  if (i.type === "allocated") {
    i._meter_unit = { id: null };
  } else {
    i._meter_unit = i._meter_unit || { id: null };
  }

  i._tariff_plan_name = (i._tariff_plan && i._tariff_plan.name) || null;
  i._tariff_plan_id = (i._tariff_plan && i._tariff_plan.id) || null;

  // if (i.type === "unitbased") {
  // } else {
  //   i._tariff_plan = { id: null };
  //   i._tariff_plan_name = null;
  //   i._tariff_plan_id = null;
  // }

  i.path = [];
  i._meter_unit.id &&
    i.path.push({
      name: i._meter_unit.name,
      id: i._meter_unit.id,
      to: "meter-unit"
    });
  !i.path.length &&
    i.path.push({
      name: (i.distribution_key || "") + (i.distribution_key_unit || "")
    });

  i.consumption_metering = i._meter_unit.id;

  i.factors = FactorParser(i.compensation_factors);
  return i;
}
function prepareItemBeforeSend(item) {
  item._tariff_plan = {
    id: item._tariff_plan_name?.value || item._tariff_plan_id || null
  };
  item._meter_unit = {};
  let meterUnitId = (item.consumption_metering || "_").split("_")[0];
  item._meter_unit.id = "" !== meterUnitId ? meterUnitId : null;
  if (item.type !== "allocated") {
    item.distribution_key = null;
    item.distribution_key_unit = null;
  } else {
    item._meter_unit = {
      id: null
    };
  }
  if (item.type === "distributed") {
    item._tariff_plan = {
      id: item._tariff_plan_name?.value || item._tariff_plan_id || null
    };
  }

  // if (item.type !== "unitbased") {
  //   item._tariff_plan = {
  //     id: null
  //   };
  //   item._tariff_plan_name =  null;
  //   item._tariff_plan_id =  null;
  // }
  if (item.factors) {
    item.compensation_factors = FactorDecoder(item.factors);
  }
  if (item.provider_id) {
    item._provider = { id: item.provider_id };
  }
  if (item.consumer_id) {
    item._consumer = { id: item.consumer_id };
  }
  // item.type = item.type.value || item.type;

  delete item.consumer_id;
  delete item.consumer_name;
  delete item.provider_id;
  delete item.provider_name;
  delete item.consumption_metering;
  delete item._tariff_plan_name;
  delete item._tariff_plan_id;
  delete item.calculation_base;

  return item;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getItem(state, getters) {
    let item = crud.getters.getItem(state);
    return prepareItem(item, getters.getTypes);
  },
  getList(state, getters) {
    let list = crud.getters.getList(state);
    return list.map(item => prepareItem(item, getters.getTypes));
  },
  getTypes() {
    return [
      { value: "allocated", text: i18n.t("cost-allocators.allocated") },
      { value: "distributed", text: i18n.t("cost-allocators.distributed") },
      { value: "unitbased", text: i18n.t("cost-allocators.unit-based") }
    ];
  }
};

const actions = {
  ...crud.actions,
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item = prepareItemBeforeSend(item);
    return crud.actions.create(_, { item, errorHandler, onSuccess });
  },
  update(
    _,
    { item, errorHandler = () => {}, onError = () => {}, onSuccess = () => {} }
  ) {
    item = prepareItemBeforeSend(item);

    return crud.actions.update(_, { item, errorHandler, onError, onSuccess });
  },
  ...roles.actions
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
